module.exports = {
  'specialismsList': [
    "aeronautique",
    "agroalimentaire",
    "banque-assurance",
    "comptabilite-gestion-paie",
    "electricite-chauffage-climatisation",
    "finition",
    "generaliste",
    "gros-uvre-travaux-publics",
    "conduite-sur-route",
    "agriculture",
    "btp",
    "handicap",
    "logistique",
    "logistique-commerce",
    "mecanique-maintenance-electricite-industrielle",
    "metallurgie-chaudronnerie-soudure",
    "metier-de-l-assistanat",
    "recrutement",
    "relation-clients",
    "commerce-distribution",
    "culture-loisirs-sport",
    "energie-environnement",
    "enseignement",
    "finance-banque",
    "hotellerie-restauration",
    "immobilier",
    "industrie",
    "industrie-agroalimentaire",
    "industrie-automobile",
    "industrie-pharmaceutique",
    "industrie-textile",
    "publicite-edition-multimedia",
    "recherche-ingenierie",
    "reparation-maintenance",
    "sante-social",
    "secteur-associatif",
    "secteur-public",
    "services-a-la-personne",
    "services-aux-entreprises",
    "systeme-d-information",
    "tourisme",
    "transport-et-logistique",
    "electricite-mecanique-metallurgie",
    "tertiaire-services",
    "transport-logistique"
  ],
  'regionList': [
    'poitou-charentes',
    'dom-rom',
    'monaco',
    'auvergne-rhuene-alpes',
    "auvergne-rhone-alpes",
    'rhone-alpes',
    'ile-de-france',
    'iles-du-vent',
    'provence-alpes-cote-dazur',
    'provence-alpes-cote-d-azur',
    'pays-de-la-loire',
    'midi-pyrenees',
    'aquitaine',
    'auvergne',
    'basse-normandie',
    'bretagne',
    'centre',
    'nord-pas-de-calais',
    'bourgogne',
    'languedoc-roussillon',
    'alsace',
    'lorraine',
    'haute-normandie',
    'franche-comte',
    'champagne-ardenne',
    'picardie',
    'occitanie',
    'bourgogne-franche-comte',
    'centre-val-de-loire',
    'corse',
    'grand-est',
    'hauts-de-france',
    'normandie',
    'nouvelle-aquitaine',
    "normandy",
    "corsica",
    "guadeloupe",
    "departements-doutre-mer",
    "departements-d-outre-mer",
    "territoires-doutre-mer",
    "territoires-d-outre-mer",
    "la-reunion",
  ],
  'departmentsList': [
    'saint-martin',
    'saint-pierre-et-piquelon',
    'monaco',
    "ain",
    "aisne",
    "allier",
    "alpes-de-haute-provence",
    "hautes-alpes",
    "alpes-maritimes",
    "ardeche",
    "ardennes",
    "ariege",
    "aube",
    "aude",
    "aveyron",
    "bouches-du-rhone",
    "calvados",
    "cantal",
    "charente",
    "charente-maritime",
    "cher",
    "correze",
    "corse-du-sud",
    "cote-d'or",
    "cotes-d'armor",
    "creuse",
    "dordogne",
    "doubs",
    "drome",
    "eure",
    "eure-et-loir",
    "finistere",
    "gard",
    "haute-garonne",
    "gers",
    "gironde",
    "herault",
    "ille-et-vilaine",
    "indre",
    "indre-et-loire",
    "isere",
    "jura",
    "landes",
    "loir-et-cher",
    "loire",
    "haute-loire",
    "loire-atlantique",
    "loiret",
    "lot",
    "lot-et-garonne",
    "lozere",
    "maine-et-loire",
    "manche",
    "marne",
    "haute-marne",
    "mayenne",
    "meurthe-et-moselle",
    "meuse",
    "morbihan",
    "moorea-maiao",
    "moselle",
    "nievre",
    "nord",
    "oise",
    "orne",
    "pas-de-calais",
    "puy-de-dome",
    "pyrenees-atlantiques",
    "hautes-pyrenees",
    "pyrenees-orientales",
    "bas-rhin",
    "haut-rhin",
    "rhone",
    "haute-saone",
    "saone-et-loire",
    "sarthe",
    "savoie",
    "haute-savoie",
    "paris",
    "seine-maritime",
    "seine-et-marne",
    "yvelines",
    "deux-sevres",
    "somme",
    "tarn",
    "tarn-et-garonne",
    "var",
    "vaucluse",
    "vendee",
    "vienne",
    "haute-vienne",
    "vosges",
    "yonne",
    "territoire-de-belfort",
    "essonne",
    "hauts-de-seine",
    "seine-saint-denis",
    "val-de-marne",
    "val-d'oise",
    "guadeloupe",
    "martinique",
    "guyane",
    "la-reunion",
    "mayotte",
    "haute-corse",
    "lyon-metropolis"
  ]
};
